<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-card
    class="pa-4"
    color="#efefef"
    elevation="0"
  >
    <template v-if="!success">
      <div style="display: grid;grid-template-columns: repeat(2,1fr)">
        <date-range-picker
          v-model="dates"
          class="mr-4"
        />
        <div
          v-if="dates"
          class="pa-1 flex-grow-1"
        >
          <div class="d-flex align-center">
            <h3>{{ $t('searchResult') }}</h3>
          </div>
          <div>{{ $t('clickButtonPrint') }}</div>
          <v-btn
            :loading="loading"
            block
            class="mt-2"
            color="primary"
            elevation="0"
            @click="print"
          >
            {{ $t('reprint') }}
          </v-btn>
        </div>
      </div>
    </template>
    <template v-else>
      <div style="height: 200px">
        <h3>{{ $t('success') }}</h3>
        <p>{{ $t('need30seconds') }}</p>
        <v-btn
          color="primary"
          outlined
          @click="reset"
        >
          <v-icon left>
            mdi-arrow-left
          </v-icon>
          {{ $t('returnToHomeAndExportOther') }}
        </v-btn>
      </div>
    </template>
  </v-card>
</template>

<script>
  import DateRangePicker from '@/composable/DateRangePicker'
  import { loadZBonList } from '@/common/common'
  import Zbon from '@/model/export/Zbon'
  import { getNiceRestaurantInfo, printSummaryBon } from '@/common/Utlis/api'
  import IKUtils from 'innerken-js-utils'
  import { showSuccessMessage } from '@/common/utils'

  export default {
    name: 'XbonExport',
    components: { DateRangePicker },
    data: function () {
      return {
        dates: null,
        model: Zbon,
        zbonEmail: '',
        loading: false,
        success: false,
      }
    },
    watch: {
      dates: {
        immediate: true,
        handler (val) {
          if (val) {
            this.loadZBonList()
          }
        },
      },
    },
    async mounted () {
      this.zbonEmail = (await getNiceRestaurantInfo()).ZBonEmail
      this.success = false
    },
    methods: {
      reset () {
        this.success = false
        this.loading = false
        this.dates = null
      },
      async loadZBonList () {
        this.zbonList = await loadZBonList(...this.dates)
        console.log(this.zbonList)
      },
      async print () {
        this.loading = true
        IKUtils.showLoading()
        const timeSpan = { timespan: this.dates.join(' - ') }
        try {
          await printSummaryBon(timeSpan)
          showSuccessMessage('Erfolgreich drucken!')
        } catch (e) {

        }
        this.success = true
        this.loading = false
      },
    },
  }
</script>

<style scoped>

</style>
